import { message } from 'antd'

export const rolesConfig = [
    { name: 'login.userTypeIndividual', values: ['login.userNoNumber', 'login.userClient'] },
    {
        name: 'login.userTypeEntrepreneur',
        values: ['login.userNoNumber', 'login.userClient', 'login.userOwner'],
    },
    {
        name: 'login.userTypeEntity',
        values: ['login.userNoNumber', 'login.userClient', 'login.userOwner', 'login.userTSO'],
    },
]

export const checkErrorPairs = (role: number, type: number, t?: any) => {
    if ((role === 4 && [0, 1].includes(type)) || (role === 3 && type === 0)) {
        message.error(t('login.errorRoleTypePair'))
    }
}
